import { connect } from "react-redux";
import RateMoto from "../components/Rate/Moto";

const RateMotoPage = ({ accessToken, currentLang }) => {
  return <RateMoto accessToken={accessToken} currentLang={currentLang} />;
};

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(RateMotoPage);
